import React from 'react'
import styled from 'styled-components'
// import { rem } from 'polished'
import { Link } from 'gatsby'
import { Flex, Box } from 'rebass'

import { media } from '../../../utils/style'

const LocationCard = styled(({ theme, ...rest }) => <Flex {...rest} />)`
  text-align: center;
  position: relative;
  z-index: 0;
  ${media.MediumScreenUp`
    &:before{
      content: '';
      position: absolute;
      z-index: -1;
      bottom: 5px;
      left: 50%;
      transform: translateX(-50%);
      width: 80%;
      height: 20px;
      box-shadow: 0 25px 25px 0px rgba(66,76,94,0.05), 0 20px 20px 0 rgba(0,0,0,0.01);
    }
  `};
`

const LocationAddress = styled(Box)`
  line-height: 1.45;
  color: ${(props) => props.theme.colors.grey_op80};
`

const LocationImage = styled(Box)`
  min-height: 1px; /* Fixes excess space in IE11: https://github.com/philipwalton/flexbugs/issues/75 */

  img {
    margin-bottom: 0;
  }
`

const LocationContent = styled(Box)`
  position: relative;
  flex: 1 0 auto;
`

const LocationCtaWrapper = styled(Box)`
  position: relative;
  z-index: 2;
`

const LocationBrands = styled(Flex)`
  align-items: center;
  justify-content: center;
  svg {
    transform: scale(1.4);
    opacity: 0.6;
  }
`

const LocationOverlay = styled(Link)`
  background: lime;
  opacity: 0;
  position: absolute;
  top: 0;
  right: 18px;
  bottom: 0;
  left: 18px;
  z-index: 1;
  user-select: none;
`

export {
  LocationCard,
  LocationAddress,
  LocationImage,
  LocationCtaWrapper,
  LocationBrands,
  LocationContent,
  LocationOverlay
}
